import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { memo } from "react";
import { connect } from "react-redux";
import OverviewHeader from "src/modules/3rd-party-management/pages/admin/carrier-guard/carriers/details/components/overview-header";
import AiSummary from "./components/ai-summary";
import StatisticsWidgets from "./components/statistics-widgets";
import SearchOverview from "./components/search-overview";
import CorporateStructureComparison from "./components/corporate-structure-comparison";
import CrossCheckAnalysis from "./components/cross-check-analysis";
import TopPackagingProducts from "./components/top-packaging-products";
import PackagingMaterialOverview from "./components/packaging-material-overview";
import RiskLevelChart from "./components/risk-level-chart";
import TasksChart from "./components/tasks-chart";
import LatestFindings from "./components/latest-findings";
import CommunicationBoxes from "./components/communication-boxes";
import RecentActivity from "./components/recent-activity";
import EudrComplianceCheck from "./components/eudr-compliance-check";
import EsgRating from "./components/esg-rating";

import GeolocationData from "src/modules/3rd-party-management/components/eudr/geolocation-data";
import SubmissionToTrace from "src/modules/3rd-party-management/components/eudr/submission-to-trace";
import UpcomingShipmentsMissingDds from "src/modules/3rd-party-management/components/eudr/upcoming-shipments-missing-dds";
import TopDeforestationHotspotRegions from "src/modules/3rd-party-management/components/eudr/top-deforestation-hotspot-regions";
import TopRelevantProductsByRiskLevel from "src/modules/3rd-party-management/components/eudr/top-relevant-products-by-risk-level";
import PackagingTonnageTrend from "src/modules/3rd-party-management/components/ppwr/packaging-tonnage-trend";

import { Col, Row } from "reactstrap";

import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";

const OverviewContentForNormalUsers = ({ supplierId, isOwnCompany, modules }) => {
    const hasKYBFeature = modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('kyb_activation');
    
    const hasNewsMonitoringFeature = modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('news_monitoring');

    const hasComplianceMonitoringFeature = modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('compliance_monitoring_activation');

    const hasComplianceScreeningFeature = modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('compliance_screening_activation');

    return (
        <div className="overview-content">
            <Row>
                <Col sm="12" className="mb-4">
                    <OverviewHeader supplierId={supplierId} settings={{
                        status: {
                            editable: true
                        },
                        analystAdmin: {
                            editable: true
                        },
                        flagging: {
                            editable: true
                        }
                    }} />
                </Col>
                
                {hasKYBFeature && (
                    <Col sm="12">
                        <AiSummary supplierId={supplierId} />
                    </Col>
                )}

                <Col sm="12">
                    <StatisticsWidgets 
                        supplierId={supplierId} 
                    />
                </Col>

                {supplierId.toString() === '7286' && (
                    <Col sm="12">
                        <EsgRating supplierId={supplierId} />
                    </Col>
                )}

                {(hasComplianceMonitoringFeature || hasComplianceScreeningFeature) && (
                    <Col sm="12">
                        <SearchOverview 
                            hasComplianceMonitoringFeature={hasComplianceMonitoringFeature}
                            hasComplianceScreeningFeature={hasComplianceScreeningFeature}
                            supplierId={supplierId} 
                        />
                    </Col>
                )}

                <Col sm="12">
                    <CorporateStructureComparison 
                        hasKYBFeature={hasKYBFeature}
                        supplierId={supplierId} 
                    />
                </Col>

                {/* <Col sm="12">
                    <NextSteps supplierId={supplierId} />
                </Col> */}

                {hasKYBFeature && (
                    <Col sm="12">
                        <CrossCheckAnalysis supplierId={supplierId} />
                    </Col>
                )}

                {/* <Col sm="12">
                    <Row>
                        <Col sm="12" md="6" lg="8">
                            <EudrComplianceCheck supplierId={supplierId} />
                        </Col>

                        <Col sm="12" md="6" lg="4">
                            <RecentActivity supplierId={supplierId} />
                        </Col>
                    </Row>
                </Col> */}

                <Col sm="12">
                    <Row>
                        <Col sm="12" md="4">
                            <RiskLevelChart
                                supplierId={supplierId}
                                isOwnCompany={isOwnCompany}
                            />
                        </Col>

                        <Col sm="12" md="4">
                            <TasksChart supplierId={supplierId} />
                        </Col>

                        <Col sm="12" md="4">
                            <RecentActivity supplierId={supplierId} />
                        </Col>
                    </Row>
                </Col>

                {hasNewsMonitoringFeature && (
                    <Col sm="12">
                        <LatestFindings supplierId={supplierId} />
                    </Col>
                )}

                <Col sm="12">
                    <CommunicationBoxes
                        supplierId={supplierId}
                        isOwnCompany={isOwnCompany}
                    />
                </Col>
            </Row>
        </div>
    );
}

const OverviewContentForDemo = ({ supplierId }) => {
    return (
        <div className="overview-content">
            <Row className="g-4 overview-demo-dashboard">
                <Col xs="12">
                    <OverviewHeader supplierId={supplierId} settings={{
                        status: {
                            editable: true
                        },
                        analystAdmin: {
                            editable: true
                        },
                        flagging: {
                            editable: true
                        }
                    }} />
                </Col>

                <Col xs="12">
                    <AiSummary supplierId={supplierId} />
                </Col>

                <Col xs="12">
                    <StatisticsWidgets supplierId={supplierId} />
                </Col>

                <Col
                    xs="12"
                    xl="5"
                    className="d-flex overview-demo-dashboard__balanced-column"
                >
                    <PackagingMaterialOverview supplierId={supplierId} />
                </Col>

                <Col
                    xs="12"
                    xl="7"
                    className="d-flex overview-sustainability-card overview-demo-dashboard__balanced-column"
                >
                    <PackagingTonnageTrend />
                </Col>

                <Col xs="12">
                    <TopPackagingProducts supplierId={supplierId} />
                </Col>

                <Col
                    xs="12"
                    xl="5"
                    className="d-flex overview-sustainability-card overview-demo-dashboard__balanced-column"
                >
                    <SubmissionToTrace />
                </Col>

                <Col
                    xs="12"
                    xl="7"
                    className="d-flex overview-sustainability-card overview-demo-dashboard__balanced-column"
                >
                    <TopDeforestationHotspotRegions />
                </Col>

                <Col xs="12" className="overview-sustainability-card">
                    <EudrComplianceCheck supplierId={supplierId} />
                </Col>

                <Col xs="12" className="overview-sustainability-card">
                    <GeolocationData supplierId={supplierId} />
                </Col>

                <Col xs="12" className="overview-sustainability-card">
                    <TopRelevantProductsByRiskLevel />
                </Col>

                <Col xs="12" className="overview-sustainability-card">
                    <UpcomingShipmentsMissingDds />
                </Col>
            </Row>
        </div>
    );
}

const Overview = ({
    modules,
    supplierData: supplierInfos
}) => {
    const supplierId = supplierInfos.id;

    if (supplierId.toString() === '7436') {
        return (
            <OverviewContentForDemo 
                supplierId={supplierId}
                isOwnCompany={!!supplierInfos?.isOwnCompany}
                modules={modules}
            />
        )
    }

    return (
        <OverviewContentForNormalUsers 
            supplierId={supplierId}
            isOwnCompany={!!supplierInfos?.isOwnCompany}
            modules={modules}
        />
    )
};

const mapStatetoProps = (state) => {
    const { Modules } = state;

    return {
        modules: Modules
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(memo(Overview)))
);
